export const LOAD_BEACON_HEALTHCHECK = 'BEACON_HEALTHCHECK:LOAD';
export const REFRESH_BEACON_HEALTHCHECK = 'BEACON_HEALTHCHECK:REFRESH';
export const RUN_BEACON_QUICKCHECK = 'BEACON_HEALTHCHECK:RUN_QUICKCHECK';
